/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-22 17:27:51
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\register\locales\zh-TW.ts
 */
export default {
  'page.user.register.form-item-username': '請輸入註冊帳號郵箱',
  'page.user.register.form-item-username.required': '輸入正確的郵箱帳號',
  'page.user.register.form-item-password': '請輸入註冊密碼(6-20位)',
  'page.user.register.form-item-password.required': '請輸入密碼',
  'page.user.register.form-item-confirmpassword': '確認密碼',
  'page.user.register.form-item-confirmpassword.compare': '您輸入的兩個密碼不匹配！',
  'page.user.register.form.title': '註冊賬戶',
  'page.user.register.form.btn-submit': '註冊',
  'page.user.register.form.btn-jump': '已有賬戶？現在登錄！',
  'page.user.register.form.register-success': '註冊成功，請登錄！',
  'page.user.register.form.agreement.start': '我已閱讀並同意',
  'page.user.register.form.agreement.agre': '《用戶協議》',
  'page.user.register.form.agreement.desc': '《用戶隱私說明》'
};
